export const Noise = () => (
  <div
    aria-hidden="true"
    className="noise-overlay pointer-events-none fixed inset-0 z-[60] opacity-[0.05]"
  />
);
